import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { objectFitCoverImageStyles, SDUIImage } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Image/SDUIImage";
import { getCssAlignmentValue } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/getCssAlignmentValue";
import { convertServerResponsivePropertyToClientResponsiveProperty, getResponsiveValueAtIndex } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import { SDUIBannerTextContent } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/BannerTextContent/SDUIBannerTextContent";
import * as styles from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/ImageBannerV2/styles/SDUIImageBannerV2Renderer.css";
import { IMAGE_BANNER_HEIGHTS } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/ImageBannerV2/styles/SDUIImageBannerV2Renderer.css";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";
export var SDUIImageBannerV2Renderer = function(param) {
    var bannerComponent = param.bannerComponent, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour;
    var images = bannerComponent.images, responsive_images = bannerComponent.responsive_images, vertical_content_alignment = bannerComponent.vertical_content_alignment;
    var responsiveImages = convertServerResponsivePropertyToClientResponsiveProperty(images, function(img) {
        return img;
    }, responsive_images);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.imageBannerV2Wrapper, // TODO - padding should be defined in the component width instead of applying
        // view-specific styling. Need to revisit component width definitions.
        loggingData.view_display_page === DisplayPageType.HOMEPAGE ? styles.desktopHomepagePaddingWrapper : undefined),
        children: [
            /*#__PURE__*/ _jsx(SDUIImage, {
                responsiveImage: getResponsiveValueAtIndex(responsiveImages, 0, IImage.build()),
                optimizeImageOptions: {
                    mobileAndAbove: {
                        height: IMAGE_BANNER_HEIGHTS.mobileAndAbove
                    },
                    tabletAndAbove: {
                        height: IMAGE_BANNER_HEIGHTS.tabletAndAbove
                    },
                    desktopAndAbove: {
                        height: IMAGE_BANNER_HEIGHTS.desktopAndAbove
                    }
                },
                className: styles.backgroundImageWrapper,
                imageStyles: objectFitCoverImageStyles,
                renderBehaviour: renderBehaviour
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageBannerV2ContentWrappper,
                style: assignInlineVars(_define_property({}, styles.verticalContentAlignment, "".concat(getCssAlignmentValue(vertical_content_alignment, "center")))),
                children: /*#__PURE__*/ _jsx(SDUIBannerTextContent, {
                    className: styles.imageBannerV2Content,
                    "data-test-id": "image-banner-v2-content",
                    bannerComponent: bannerComponent,
                    loggingData: loggingData
                })
            })
        ]
    });
};
